/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-empty-function */
// @ts-ignore
import bootstrap from './bootstrap';
bootstrap(() => {});